var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_923_3683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1267 12.6409C17.1163 10.6809 17.9859 9.2016 19.7461 8.11215C18.7612 6.67557 17.2734 5.88518 15.3089 5.73031C13.4492 5.58077 11.4166 6.83578 10.6727 6.83578C9.88689 6.83578 8.08478 5.78371 6.67034 5.78371C3.74716 5.83178 0.640625 8.16021 0.640625 12.8972C0.640625 14.2964 0.892081 15.7419 1.39499 17.2336C2.06554 19.1936 4.48581 24 7.01085 23.9199C8.331 23.8878 9.26348 22.964 10.9818 22.964C12.6477 22.964 13.512 23.9199 14.9841 23.9199C17.5301 23.8825 19.7199 19.514 20.359 17.5487C16.9434 15.9092 17.1267 12.7423 17.1267 12.6409ZM14.1616 3.87183C15.5918 2.14152 15.4608 0.566088 15.4189 0C14.1564 0.0747664 12.6948 0.875834 11.8619 1.86382C10.9451 2.92123 10.4055 4.22964 10.5208 5.7036C11.8881 5.81041 13.1349 5.09479 14.1616 3.87183Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_923_3683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosIcon);
export default __webpack_public_path__ + "static/media/iosIcon.860a6b89.svg";
export { ForwardRef as ReactComponent };